import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { strings } from '/imports/strings';
import { Page } from '/imports/ui/Page';
import { useUser } from '/imports/hooks';
import { NotPermittedPage } from '/imports/ui/NotPermittedPage';
import { modelClass, Settings, settingsId } from '/imports/api/settings';
import { autoForm, formConfig } from '/imports/ui/AutoForm';
import { PageHeading } from '/imports/ui/PageHeading';
import { PageBody } from '/imports/ui/PageBody';
import { Checkbox } from '/imports/ui/Checkbox';

const SettingsPageStyled = styled(Page)``;

/** Super-user-only page for editing global application settings. */
export const SettingsPage = () => {
  const user = useUser();
  if (!user?.isSuperUser) return <NotPermittedPage />;
  const [initialized, setInitialized] = useState(false);
  const [settings, setSettings] = useState<Settings>();
  const [update, setUpdate] = useState<Partial<Settings>>({ _id: settingsId });
  useEffect(() => {
    (async () => {
      setSettings(await modelClass.getMethod.call(settingsId));
      setInitialized(true);
    })();
  }, []);
  const [SettingsForm] = autoForm({
    document: settings,
    createMethod: modelClass.updateMethod as any,
    updateMethod: modelClass.updateMethod as any,
    update, setUpdate,
    form: formConfig<Settings>([
      [{ field: 'quoteRequestRecipients', label: strings.SettingsQuoteRequestRecipients() }],
      [{ field: 'playwrightHeaded', label: strings.SettingsPlaywrightHeaded(), input: { type: Checkbox } }],
      [{ field: 'playwrightDisplayServer', label: strings.SettingsPlaywrightDisplayServer() }],
    ]),
  });
  return (
    <SettingsPageStyled className={`page${!initialized ? ' initializing' : ''}`}>
      <PageHeading
        left={<h1>{strings.Settings()}</h1>}
      />
      <PageBody>
        {SettingsForm}
      </PageBody>
    </SettingsPageStyled>
  );
};